export default __webpack_public_path__ + "static/media/catalog.cc1f122c.pdf";